import { cloneJSON } from '@utiljs/clone';
import defaultLang from './lang/zh-CN';
var _langPlus = defaultLang;
var _rtl = false;

var use = function use(lang) {
  _langPlus = lang || {};
};

var lng = function lng(path) {
  var value = cloneJSON(_langPlus);
  var arr = path.split('.');
  arr.forEach(function (i) {
    // @ts-ignore
    value = value[i];
  });
  return value || '';
};

var useRtl = function useRtl(rtl) {
  _rtl = rtl;

  if (_rtl) {
    document.documentElement.setAttribute('dir', 'rtl');
    document.documentElement.setAttribute('class', 'roo-rtl');
  } else {
    document.documentElement.setAttribute('dir', 'ltr');
    document.documentElement.setAttribute('class', '');
  }
};

var rtl = function rtl() {
  return _rtl;
};

export default {
  use: use,
  lng: lng,
  useRtl: useRtl,
  rtl: rtl
};